import React from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import { Helmet } from 'react-helmet';
import 'react-table/react-table.css';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import { requestIcdLookup } from '../../../store/icd-lookup/IcdLookupActions';
import Pagination from '../../../components/common/Pagination';
import InfoBar from '../../../components/common/InfoBar';
import { hashHistory } from 'react-router';
import { hostTitle } from '../../../config/ui';
import { isExecutive } from '../../../store/current-user/CurrentUserSelectors';

class ICDLookup extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pageSize: 25, page: 0, pages: -1, search: '', sorted: [] };
    this.handleSearch = this.handleSearch.bind(this);
  }

  fetchData = (state) => {
    const offset = state.page * state.pageSize;
    const limit = state.pageSize;
    const order = state.sorted
      .map((item) => `${item.desc ? 'desc' : 'asc'} ${item.id}`)
      .join();
    const filters = state.filtered
      .map((item) => `${item.value} ${item.id}`)
      .join();
    const search = this.state.search;
    return this.props
      .getIcdLookup({
        offset: offset,
        limit: limit,
        order: order,
        search: search,
        filters: filters,
        tenantId: this.props.tenantId,
      })
      .then((response) =>
        this.setState({
          pages: response.payload.data.total
            ? Math.ceil(response.payload.data.total / this.state.pageSize)
            : 0,
        }),
      );
  };

  handleSearch = (search) =>
    this.setState({ search, page: 0 }, () => this.table.fireFetchData());

  editIcd = (key, icd10) => {
    hashHistory.push(`/icd-lookup/icd/${key}-${icd10}`);
  };

  addIcd = (key) => {
    hashHistory.push(`/icd-lookup/icd/${key}`);
  };

  render() {
    const { data, isExecutive } = this.props;
    return (
      <div id="content">
        <Helmet title={`ICD Lookup – ${hostTitle()}`} />
        <div className="table-layout content-ribbon">
          <div className="table-cell">
            <BigBreadcrumbs
              items={['Resource Library', 'ICD Lookup']}
              icon="fa fa-fw fa-book"
              className=""
            />
          </div>
          <div className="table-cell">
            <InfoBar
              className=""
              total={data.total}
              pages={this.state.pages}
              page={this.state.page + 1}
            />
          </div>
        </div>
        <WidgetGrid>
          <div className="row">
            <article className="col-sm-12">
              <JarvisWidget
                color="white"
                fullscreenbutton={true}
                colorbutton={false}
                editbutton={false}
                togglebutton={false}
                deletebutton={false}
              >
                <header>
                  <span className="widget-icon">
                    {' '}
                    <i className="fa fa-table" />{' '}
                  </span>{' '}
                  <h2>ICD Lookup</h2>
                </header>
                <button disabled={isExecutive}
                  className="btn btn-primary "
                  onClick={() => this.addIcd(0)}
                >
                  Add New
                </button>
                <div>
                  <div className="widget-body no-padding">
                    <ReactTable
                      ref={(instance) => {
                        this.table = instance;
                      }}
                      page={this.state.page}
                      manual
                      pages={this.state.pages}
                      loading={this.props.isLoading}
                      data={this.props.data ? this.props.data.list : []}
                      onFetchData={this.fetchData}
                      columns={[
                        {
                          Header: 'Key',
                          id: 'key',
                          accessor: 'key',
                        },
                        {
                          Header: 'ICD10',
                          id: 'icd10',
                          accessor: 'icd10',
                        },
                        {
                          Header: 'Description',
                          id: 'description',
                          accessor: 'description',
                        },
                        {
                          Header: 'Code',
                          id: 'code',
                          accessor: 'code',
                        },
                        {
                          Header: 'Group',
                          id: 'group',
                          accessor: 'group',
                        },
                        {
                          Header: 'Group Description',
                          id: 'groupDescription',
                          accessor: 'groupDescription',
                        },
                        {
                          Header: 'Chronic Indicator',
                          id: 'chronicIndicator',
                          accessor: 'chronicIndicator',
                        },
                        {
                          Header: 'Body System',
                          id: 'bodySystem',
                          accessor: 'bodySystem',
                        },
                        {
                          Header: 'Inscope',
                          id: 'inscope',
                          accessor: (d) => (d.inscope ? 'True' : 'False'),
                        },
                        {
                          Header: '',
                          id: 'actions',
                          width: 60,
                          sortable: false,
                          Cell: (row) => (
                            <span>
                              <button disabled={isExecutive}
                                className="btn btn-primary btn-circle"
                                onClick={() =>
                                  this.editIcd(
                                    row.original.key,
                                    row.original.icd10,
                                  )
                                }
                              >
                                <i className="glyphicon glyphicon-edit"></i>
                              </button>
                            </span>
                          ),
                        },
                      ]}
                      defaultPageSize={this.state.pageSize}
                      onPageSizeChange={(pageSize) =>
                        this.setState({ pageSize })
                      }
                      onPageChange={(page) => this.setState({ page })}
                      filterable
                      className="-striped -highlight"
                      showPaginationTop={true}
                      PaginationComponent={Pagination}
                      onSearchChange={this.handleSearch}
                    />
                  </div>
                </div>
              </JarvisWidget>
            </article>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.icdlookup,
    tenantId: state.currentUser.queryParams.tenantId,
    isExecutive: isExecutive(state),
  }),
  (dispatch) => ({
    getIcdLookup: (params) => dispatch(requestIcdLookup(params)),
  }),
)(ICDLookup);



// WEBPACK FOOTER //
// ./src/routes/resource-library/containers/ICDLookup.js